import { DatePicker, Form, Select, Radio } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

import moment from "moment";

import { ELSTER_FIELDS_ENTRIES } from "../../../BWAView/elsterFields";
import type { ExportEURTransactionsFormValues } from "./types";

const EXCLUDED_ELSTER_CODES: string[] = [
  "140",
  "108b",
  "106",
  "159",
  "136",
  "131",
  "130",
  "132",
  "137",
  "135",
  "185",
  "171",
  "172",
  "147",
  "199",
  "219",
];

const options = ELSTER_FIELDS_ENTRIES.filter(
  ([code]) => !EXCLUDED_ELSTER_CODES.includes(code)
).map(([code, definition]) => ({
  value: code,
  label: `${code} - ${definition.description}`,
}));

export const initialExportEURTransactionsValues: Partial<ExportEURTransactionsFormValues> =
  {
    date: moment(),
    fileType: "csv",
  };

const getTexts = (t: TFunction) => {
  const keyPrefix = "command.exportEURTransactions";
  return {
    date: {
      label: t(`${keyPrefix}.date.label`, "Date"),
      placeholder: t(`${keyPrefix}.date.placeholder`, "Select date"),
    },
    fileType: {
      label: t(`${keyPrefix}.fileType.label`, "File Type"),
      options: {
        pdf: t(`${keyPrefix}.fileType.options.pdf`, "PDF"),
        csv: t(`${keyPrefix}.fileType.options.csv`, "CSV"),
      },
    },
    elsterField: {
      label: t(`${keyPrefix}.elsterField.label`, "Elster Field"),
      placeholder: t(
        `${keyPrefix}.elsterField.placeholder`,
        "Select Elster field"
      ),
    },
  };
};

export const ExportEURTransactions: React.FC = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);

  return (
    <>
      <Form.Item
        name="date"
        label={texts.date.label}
        initialValue={initialExportEURTransactionsValues.date}
      >
        <DatePicker
          id="date"
          placeholder={texts.date.placeholder}
          picker="year"
          disabledDate={(date: moment.Moment) =>
            date && date.year() > moment().year()
          }
        />
      </Form.Item>

      <Form.Item
        label={texts.fileType.label}
        name="fileType"
        initialValue={initialExportEURTransactionsValues.fileType}
      >
        <Radio.Group
          options={[
            { label: texts.fileType.options.csv, value: "csv" },
            { label: texts.fileType.options.pdf, value: "pdf" },
          ]}
          optionType="button"
        />
      </Form.Item>

      <Form.Item label={texts.elsterField.label} name="elsterField">
        <Select
          showSearch
          placeholder={texts.elsterField.placeholder}
          optionFilterProp="label"
          options={options}
        />
      </Form.Item>
    </>
  );
};

export default ExportEURTransactions;
